import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBoeingComponent } from './simple-icons-boeing.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBoeingComponent ],
    exports:      [ SimpleIconsBoeingComponent ],
    bootstrap:    []
})
export class SimpleIconsBoeingModule {}
